import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputTextarea } from 'primereact/inputtextarea';
import { useLanguage } from '../../../../contexts/LanguageContext';
import { useProcessPurchaseRequestMutation } from '../../../../api/endpoints/vehicleSale';
import { toastService } from '../../../../utils/toastService';
import { REQUEST_ACTION } from '../utils/statusBadges';

const RejectRequestDialog = ({ visible, request, onHide, onSuccess }) => {
    const { th, getCurrentLanguageId } = useLanguage();
    const languageId = getCurrentLanguageId();
    const [responseMessage, setResponseMessage] = useState('');
    const [validationError, setValidationError] = useState('');

    const [processRequest, { isLoading }] = useProcessPurchaseRequestMutation();

    useEffect(() => {
        if (visible) {
            setResponseMessage('');
            setValidationError('');
        }
    }, [visible]);

    if (!request) return null;

    const handleSubmit = async () => {
        const trimmed = responseMessage?.trim();
        if (!trimmed) {
            setValidationError(th('vehiclesForSale.validation.rejectReasonRequired'));
            return;
        }
        setValidationError('');
        try {
            const res = await processRequest({
                requestId: request.requestId,
                action: REQUEST_ACTION.REJECT,
                responseMessage: trimmed,
                languageId
            }).unwrap();

            if (res?.isSuccess || res?.isSuccessful) {
                toastService.success(res.message || th('vehiclesForSale.toast.requestRejected'));
                onSuccess?.();
                onHide();
            }
        } catch (err) {
            void err;
        }
    };

    const footer = (
        <div className="flex justify-content-end gap-2">
            <Button
                label={th('vehiclesForSale.buttons.cancel')}
                icon="pi pi-times"
                className="p-button-outlined"
                onClick={onHide}
                disabled={isLoading}
            />
            <Button
                label={th('vehiclesForSale.buttons.rejectRequest')}
                icon="pi pi-ban"
                className="p-button-danger"
                onClick={handleSubmit}
                loading={isLoading}
            />
        </div>
    );

    return (
        <Dialog
            visible={visible}
            onHide={onHide}
            header={th('vehiclesForSale.dialog.rejectRequestTitle')}
            style={{ width: '480px' }}
            modal
            footer={footer}
            closable={!isLoading}
        >
            <div className="field">
                <label className="block mb-2 text-sm">
                    {th('vehiclesForSale.dialog.rejectRequestPrompt')}
                </label>
                <InputTextarea
                    value={responseMessage}
                    onChange={(e) => setResponseMessage(e.target.value)}
                    rows={4}
                    className="w-full"
                    placeholder={th('vehiclesForSale.placeholders.rejectReason')}
                    maxLength={500}
                />
                {validationError && (
                    <small className="p-error block mt-1">{validationError}</small>
                )}
            </div>
        </Dialog>
    );
};

export default RejectRequestDialog;
